<template>
    <div>
    	<nav class="flex items-end">
            <span class="flex-1 justify-start flex">
                <div class="shrink-0 flex items-center">
                    <Link :href="route('home')" class="block">
                        <jet-application-logo class="block h-14 md:h-20 w-auto pointer-events-none" />
                    </Link>
                </div>
            </span>
                  
            <span class="no-print transition-all fixed top-0 h-screen bg-white w-full w-full xl:w-2/3 px-10 py-40 uppercase text-1xl font-bold  xl:space-y-0 xl:relative xl:bg-transparent xl:right-auto xl:top-auto xl:justify-end xl:space-x-4 flex flex-row xl:p-0 xl:py-auto xl:h-auto transition z-50" :class="showMenu ? 'block right-0 shadow-lg flex-col justify-start space-y-4' : ' -right-[100vw]'">
                <a :href="route('quem-somos')" class="nav-link text-primary-900" :class="{ 'active': $page.url === '/quem-somos' }">Quem Somos</a>
                <a :href="route('ofertas')" class="nav-link text-primary-900" :class="{ 'active': $page.url === '/ofertas-de-emprego' } ">Ofertas de Emprego</a>
                <a :href="route('empresas')" class="nav-link text-primary-900" :class="{ 'active': $page.url === '/empresas' } ">Para Empresas</a>
                <a :href="route('candidatos')" class="nav-link text-primary-900" :class="{ 'active': $page.url === '/candidatos' } ">Para Candidatos</a>
                <a :href="route('posts')" class="nav-link text-primary-900" :class="{ 'active': $page.url === '/publicacoes' } ">Blogue</a>
                <a :href="route('contactos')" class="nav-link text-primary-900" :class="{ 'active': $page.url === '/contactos' } ">Contactos</a>
                
                <jet-application-logo class="self-start h-10 mt-10" :class="showMenu ? 'block' : 'hidden'" />
                
            </span>

            <!-- Hamburger -->
            <div class="no-print -mr-2 flex items-center xl:hidden z-50" :class="showMenu ? 'fixed right-4' : ''">
                <button @click="showMenu = ! showMenu" class="inline-flex items-center justify-center p-2 rounded-md text-primary-900 bg-transparent focus:outline-none focus:text-primary-900 transition">
                    <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                        <path :class="{'hidden': showMenu, 'inline-flex': ! showMenu }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                            <path :class="{'hidden': ! showMenu, 'inline-flex': showMenu }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        
           <!--  <div class="space-y-1 z-50 relative lg:hidden -top-4" @click.prevent="showMenu = !showMenu">
                <span class="block w-8 h-0.5 bg-gray-600"></span>
                <span class="block w-8 h-0.5 bg-gray-600"></span>
                <span class="block w-5 h-0.5 bg-gray-600"></span>
            </div> -->
        </nav>

        <div class="no-print fixed top-0 left-0 w-full min-h-full block bg-opacity-80 z-40 bg-gray-900 pointer-events-none" v-if="showMenu"></div>
    </div>
</template>		

<script>
	import { defineComponent } from 'vue'
	import { Head, Link } from '@inertiajs/inertia-vue3';
    import JetApplicationLogo from '@/Jetstream/ApplicationLogo.vue'
    import Icon from '@/Jetstream/Icon.vue'

	export default defineComponent({

		components: {
            Head,
            Link,
            JetApplicationLogo,
            Icon
        },
        data() {
        	return {
        		showMenu: false
        	}
        },
        methods: {
        }

	})
</script>